import { Link, NavLink, Route, Routes, useLocation } from "react-router-dom";
import { Compass, Menu } from "lucide-react";
import { useEffect, useState } from "react";
import { LandingPage } from "./pages/LandingPage";
import { AssessmentPage } from "./pages/AssessmentPage";
import { PreviewPage } from "./pages/PreviewPage";
import { ReportPage } from "./pages/ReportPage";
import { AdminPage } from "./pages/AdminPage";
import { NotFoundPage } from "./pages/NotFoundPage";

function RouteScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "auto" });
      return;
    }
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
}

export default function App() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen">
      <RouteScrollManager />
      <header className="sticky top-0 z-50 border-b border-moss/10 bg-cream/90 px-5 py-4 backdrop-blur-xl md:px-10">
        <div className="shell flex items-center justify-between">
          <Link className="flex items-center gap-2 font-extrabold tracking-tight" to="/" onClick={() => setOpen(false)}><span className="grid h-9 w-9 place-items-center rounded-full bg-moss text-lime"><Compass size={19} /></span>CareerCompass <span className="text-coral">AI</span></Link>
          <button className="md:hidden" aria-label="Toggle navigation" onClick={() => setOpen((value) => !value)}><Menu /></button>
          <nav className={`${open ? "flex" : "hidden"} absolute left-5 right-5 top-16 flex-col gap-4 rounded-2xl bg-white p-5 shadow-soft md:static md:flex md:flex-row md:items-center md:bg-transparent md:p-0 md:shadow-none`}>
            <Link className="nav-link" to="/#how" onClick={() => setOpen(false)}>How it works</Link><NavLink className="nav-link" to="/admin" onClick={() => setOpen(false)}>Admin</NavLink><Link className="rounded-full bg-moss px-5 py-2.5 text-sm font-extrabold text-white" to="/assessment" onClick={() => setOpen(false)}>Start free</Link>
          </nav>
        </div>
      </header>
      <Routes>
        <Route path="/" element={<LandingPage />} /><Route path="/assessment" element={<AssessmentPage />} />
        <Route path="/preview/:reportId" element={<PreviewPage />} /><Route path="/report/:reportId" element={<ReportPage />} />
        <Route path="/admin" element={<AdminPage />} /><Route path="*" element={<NotFoundPage />} />
      </Routes>
      <footer className="mt-14 bg-ink px-5 py-10 text-white md:px-10"><div className="shell flex flex-col gap-5 md:flex-row md:items-center md:justify-between"><div className="flex items-center gap-2 font-bold"><Compass className="text-lime" /> CareerCompass AI</div><p className="max-w-2xl text-xs leading-5 text-white/45">AI-assisted exploration for students and early professionals. Built with Gemini on Google Cloud. Humans make the final decisions.</p></div></footer>
    </div>
  );
}
